import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import FormikCheckbox from '../../../../base/forms/formikCheckbox';
import FormikFieldWrapper from '../../../../base/forms/formikFieldWrapper';
import FormikSelect from '../../../../base/forms/formikSelect';
import { StyledFormikField } from '../../../../base/forms/input';
import { Column, Columns } from '../../../../base/grid';
import { IStepInfo } from '../../stepInfo.schema';

interface Props {
	values: IStepInfo;
	setFieldTouched: any;
	setFieldValue: any;
	postcodes: any;
	countries: any;
}

const showOrHideStar = values => {
	const { whoFillsOut } = values;
	const result = whoFillsOut === 'sender' ? '*' : '';
	return result;
};

const SenderFields: FC<Props> = ({ values, setFieldTouched, setFieldValue, postcodes, countries }) => {
	const { t } = useTranslation(['registerShipment', 'generalForm', 'damageReport']);
	return (
		<Columns>
			<Column>
				<FormikCheckbox
					name="senderIsForeign"
					id="senderIsForeign"
					label={t('damageReport:sender-foreign-address')}
					setFieldValue={setFieldValue}
				/>
			</Column>
			<Column tablet={1 / 2}>
				<FormikFieldWrapper
					label={`${t('step-info.name')} *`}
					name="senderName"
					languageComponent="registerShipment"
					smallLabel>
					<StyledFormikField
						type="text"
						id="senderName"
						name="senderName"
						placeholder={t('step-info.name')}
						autoComplete="name"
					/>
				</FormikFieldWrapper>
			</Column>
			<Column tablet={1 / 2}>
				<FormikFieldWrapper
					label={t('step-info.ssn')}
					name="senderSsn"
					languageComponent="registerShipment"
					smallLabel>
					<StyledFormikField type="text" id="senderSsn" name="senderSsn" placeholder={t('step-info.ssn')} />
				</FormikFieldWrapper>
			</Column>
			<Column tablet={1 / 2}>
				<FormikFieldWrapper
					label={`${t('step-info.address')} *`}
					name="senderAddress"
					languageComponent="registerShipment"
					smallLabel>
					<StyledFormikField
						type="text"
						id="senderAddress"
						name="senderAddress"
						placeholder={t('step-info.address')}
						autoComplete="address"
					/>
				</FormikFieldWrapper>
			</Column>
			{!values.senderIsForeign && (
				<Column tablet={1 / 2}>
					<FormikFieldWrapper
						label={`${t('step-info.postcode')} *`}
						name="senderZip"
						languageComponent="registerShipment"
						smallLabel>
						<FormikSelect
							id="senderZip"
							name="senderZip"
							options={postcodes}
							value={values.senderZip}
							placeholder={t('step-info.postcode')}
							onBlur={setFieldTouched}
							onChange={setFieldValue}
						/>
					</FormikFieldWrapper>
				</Column>
			)}

			{values.senderIsForeign && (
				<>
					<Column tablet={1 / 2}>
						<FormikFieldWrapper
							label={`${t('step-info.postcode')} *`}
							name="senderForeignZip"
							languageComponent="registerShipment"
							smallLabel>
							<StyledFormikField
								type="text"
								id="senderForeignZip"
								name="senderForeignZip"
								placeholder={t('step-info.postcode')}
								autoComplete="postal code"
							/>
						</FormikFieldWrapper>
					</Column>

					<Column tablet={1 / 2}>
						<FormikFieldWrapper
							label={`${t('generalForm:city')} *`}
							name="senderForeignCity"
							languageComponent="registerShipment"
							smallLabel>
							<StyledFormikField
								type="text"
								id="senderForeignCity"
								name="senderForeignCity"
								placeholder={t('generalForm:city')}
								autoComplete="city"
							/>
						</FormikFieldWrapper>
					</Column>

					<Column tablet={1 / 2}>
						<FormikFieldWrapper
							label={`${t('generalForm:chooseCountry')} *`}
							smallLabel
							name="senderForeignCountry"
							languageComponent="registerShipment">
							<FormikSelect
								id="senderForeignCountry"
								name="senderForeignCountry"
								value={values.senderForeignCountry}
								options={countries}
								onBlur={setFieldTouched}
								onChange={setFieldValue}
								placeholder={t('generalForm:chooseCountry')}
							/>
						</FormikFieldWrapper>
					</Column>
				</>
			)}

			<Column tablet={1 / 2}>
				<FormikFieldWrapper
					label={`${t('step-info.email')}${showOrHideStar(values)}`}
					name="senderEmail"
					languageComponent="registerShipment"
					smallLabel>
					<StyledFormikField
						type="text"
						id="senderEmail"
						name="senderEmail"
						placeholder={t('step-info.email')}
						autoComplete="email"
					/>
				</FormikFieldWrapper>
			</Column>
			<Column tablet={1 / 2}>
				<FormikFieldWrapper
					label={`${t('step-info.phone')} *`}
					name="senderPhone"
					languageComponent="registerShipment"
					smallLabel>
					<StyledFormikField
						type="number"
						id="senderPhone"
						name="senderPhone"
						placeholder={t('step-info.phone')}
						autoComplete="phone"
						onWheel={e => e.currentTarget.blur()} // Prevents scrolling in number input
					/>
				</FormikFieldWrapper>
			</Column>
			<Column tablet={values.senderIsForeign ? 1 / 2 : 1}>
				<FormikFieldWrapper
					label={t('step-info.contact')}
					name="senderContact"
					languageComponent="registerShipment"
					smallLabel>
					<StyledFormikField
						type="text"
						id="senderContact"
						name="senderContact"
						placeholder={t('step-info.contact')}
					/>
				</FormikFieldWrapper>
			</Column>
		</Columns>
	);
};

export default SenderFields;
